import React from 'react';
import { Card } from '../../Library/Card';
import { Grid, Typography } from '@mui/material';
import { CustomIcon } from '../../../atoms';
import { colors } from '../../../utils/theme';
import RootineButton from '../../../atoms/RootineButton';
import { CHECKOUT_URLS } from '../../../config';

export const StressResources = (): JSX.Element => {
  return (
    <Card
      content={
        <Grid container flexDirection="column">
          {/* <Grid
            container
            item
            flexDirection="row"
            alignItems="center"
            sx={{ mb: 1.5, display: 'inline' }}
          >
            <CustomIcon
              name="phone"
              hex="black"
              sx={{
                width: 20,
                height: 20,
                fill: colors.greys.BASE_WHITE,
                mb: -0.5,
              }}
            />
            <Typography variant="light" fontSize={18} sx={{ ml: 0.75 }}>
              Book a call with our clinician today
            </Typography>
          </Grid>
          <Typography variant="light" fontSize={14} sx={{ mb: 1 }}>
            Our in-house clinicians are ready to help dive deeper on your
            insights and recommendations.
          </Typography>

          <RootineButton
            variation="primary"
            hideIcon
            label="Book 1:1"
            size="medium"
            as="a"
            href={`${CHECKOUT_URLS.coaching.link}`}
          /> */}

          <Grid
            container
            item
            flexDirection="row"
            alignItems="center"
            sx={{ mb: 1.5 }}
          >
            <CustomIcon
              name="messageCircle"
              hex="black"
              sx={{
                width: 22,
                height: 22,
                fill: colors.greys.BASE_WHITE,
              }}
            />
            <Typography variant="light" fontSize={18} sx={{ ml: 0.75 }}>
              Have questions?
            </Typography>
          </Grid>
          <Typography variant="light" fontSize={14} sx={{ mb: 1 }}>
            Ask our Member Experience team for questions about your order or
            account.
          </Typography>

          <RootineButton
            variation="outline_light"
            label="Start chat"
            size="medium"
            onClick={() => {
              // @ts-ignore: Property does not exist
              window.Atlas.chat.openWindow();
            }}
          />
        </Grid>
      }
      cardStyles={{ mt: 3 }}
    />
  );
};
